import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
// import { CartAction } from '@spartacus/cart/base/core/store/actions/'

import { CartActions } from '@spartacus/cart/base/core';
import { AuthActions, GlobalMessageActions, GlobalMessageService, GlobalMessageType } from '@spartacus/core';
//import { UserAccountFacade } from '@spartacus/user/account/root';
import { Observable } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { UserAccountFacade } from 'src/feature-libs/kn-br-user/kn-br-account/root/facade';
import {
  KnBrCartRemoveContext,
  KnBrCartResetContext,
} from '../../feature-libs/kn-br-cart/base/core/store/actions/kn-br-cart-context.actions';
import { KnBrDraftOrdersService } from '../../feature-libs/kn-br-cart/saved-carts/core/facade/kn-br-draft-orders.service';
import { KnBrQuoteReferenceService } from '../../feature-libs/kn-br-cart/saved-carts/core/facade/kn-br-quote-reference.service';
import { KnBrQuoteRemoveContext } from '../../feature-libs/kn-br-cart/saved-carts/core/store/actions/kn-br-quote-context.actions';
import { KnBrProductSelectService } from '../../feature-libs/kn-br-product/core/service/kn-br-product-select.service';
import { KnBrCustomerResetContext } from '../kn-br-customer-context/kn-br-customer-context.actions';
import { KnBrCustomerContextService } from '../kn-br-customer-context/kn-br-customer-context.service';
import { CustomerSearchReset } from '../kn-br-customer/kn-br-customer.action';

@Injectable()
export class KnBrCartEffects {
  //@Effect()
  addToCartNotify$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CartActions.CART_ADD_ENTRY_SUCCESS),
      map((action: CartActions.CartAddEntrySuccess) => action.payload),
      map((product: any) => {
        this.knBrProductSelectService.setSelectedProducts([]);
        const addedEntries = product.knbrCartModificationList || [];
        const hasErrorMessages = product.errorMessage && product.errorMessage.length > 0;

        if (addedEntries.length > 0) {
          this.knBrQuoteReferenceService.addQuoteFromPDP(addedEntries[0].entryData?.entryNumber);
          if (addedEntries[0].statusCode === 'warn') {
            this.messageService.add({ raw: addedEntries[0].statusMessage }, GlobalMessageType.MSG_TYPE_WARNING);
          }
        }
        this.knBrDraftOrdersService.setAddCartEntryLoading(false);

        // Show per-product error messages (e.g. "No Price")
        if (hasErrorMessages) {
          product.errorMessage.forEach((error: any) => {
            if (error.message) {
              this.messageService.add(
                { raw: error.message },
                error.type === 'ERROR' ? GlobalMessageType.MSG_TYPE_ERROR : GlobalMessageType.MSG_TYPE_WARNING
              );
            }
          });
        }

        // Show success if products were added; show failure only when no error messages covered it
        if (addedEntries.length > 0) {
          this.messageService.add({ key: 'addToCartMessage.success' }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
        } else if (!hasErrorMessages) {
          this.messageService.add({ key: 'addToCartMessage.failure' }, GlobalMessageType.MSG_TYPE_ERROR);
        }
      })
    ),
    { dispatch: false }
  );

  //@Effect({ dispatch: false })
  addToCartFailureNotify$: Observable<any> = createEffect(
    () =>
      this.actions$.pipe(
        ofType(CartActions.CART_ADD_ENTRY_FAIL), // listen for successful Add To Draft Order
        map((action: CartActions.CartAddEntryFail) => action.payload.error), // get product from action payload
        map((error: any) => {
          this.knBrDraftOrdersService.setAddCartEntryLoading(false);
          const errors = (error?.details || []) as Array<any>;
          if (errors.length > 0) {
            errors.forEach((err) => {
              const type = err.type.toLowerCase();
              if (type.indexOf('warning') !== -1) {
                this.messageService.add({ raw: err.message }, GlobalMessageType.MSG_TYPE_WARNING);
              } else if (type.indexOf('error') !== -1) {
                this.messageService.add({ raw: err.message }, GlobalMessageType.MSG_TYPE_ERROR);
              }
            });
          } else {
            this.messageService.add({ key: 'addToCartMessage.failure' }, GlobalMessageType.MSG_TYPE_ERROR);
          }
        })
      ),
    { dispatch: false }
  );

  //@Effect({ dispatch: false })
  removeCartEntryNotify$: Observable<any> = createEffect(
    () =>
      this.actions$.pipe(
        ofType(CartActions.CART_REMOVE_ENTRY),
        map((action: any) => action.payload),
        map(() => this.knBrDraftOrdersService.setAddCartEntryLoading(true))
      ),
    { dispatch: false }
  );

  //@Effect({ dispatch: false })
  removeCartEntrySucessNotify$: Observable<any> = createEffect(
    () =>
      this.actions$.pipe(
        ofType(CartActions.CART_REMOVE_ENTRY_SUCCESS),
        map((action: any) => action.payload),
        map(() => this.knBrDraftOrdersService.setAddCartEntryLoading(false))
      ),
    { dispatch: false }
  );

  //@Effect({ dispatch: false })
  removeCartEntryFailureNotify$: Observable<any> = createEffect(
    () =>
      this.actions$.pipe(
        ofType(CartActions.CART_REMOVE_ENTRY_FAIL),
        map((action: any) => action.payload.error),
        map(() => this.knBrDraftOrdersService.setAddCartEntryLoading(false))
      ),
    { dispatch: false }
  );

  //@Effect()
  placeOrder$: Observable<any> = createEffect(() =>
    this.actions$.pipe(
      // TODO Implement EventService to listen for the OrderPlacedEvent
      ofType(),
      map((action: any) => action.payload),
      map((orderDetail) => {
        if (orderDetail && orderDetail?.warningMessage) {
          this.messageService.add({ raw: orderDetail?.warningMessage }, GlobalMessageType.MSG_TYPE_WARNING);
        }
        return new KnBrCartRemoveContext();
      })
    )
  );

  //@Effect({ dispatch: false })
  placeOrderFail$: Observable<any> = createEffect(
    () =>
      this.actions$.pipe(
        // TODO Implement EventService to listen for the OrderPlacedEvent
        ofType(),
        map((action: any) => action.payload),
        map((error: any) => {
          const errors = (error.message || error.details || []) as Array<any>;
          if (errors.length > 0) {
            this.messageService.add({ raw: errors[0].message }, GlobalMessageType.MSG_TYPE_ERROR);
          }
        })
      ),
    { dispatch: false }
  );

  //@Effect()
  login$: Observable<any> = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.LOGIN),
      map((action: any) => action.payload),
      mergeMap(() => {
        this.user$.subscribe((user: any) => {
          if (user && user.customerId) {
            this.customerContextService.set({
              customerName: user.customerName,
              customerNumber: user.customerId,
            });
          }
        });
        return [new KnBrQuoteRemoveContext(), new KnBrCartResetContext(), new CustomerSearchReset(null)];
      })
    )
  );

  //@Effect()
  logout$: Observable<any> = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.LOGOUT),
      map((action: any) => action.payload),
      mergeMap(() => {
        return [
          new KnBrQuoteRemoveContext(),
          new KnBrCartResetContext(),
          new CustomerSearchReset(null),
          new KnBrCustomerResetContext(),
        ];
      })
    )
  );

  user$ = this.userService.get();
  constructor(
    private actions$: Actions,
    private knBrQuoteReferenceService: KnBrQuoteReferenceService,
    private knBrProductSelectService: KnBrProductSelectService,
    private customerContextService: KnBrCustomerContextService,
    private userService: UserAccountFacade,
    private knBrDraftOrdersService: KnBrDraftOrdersService,
    private messageService: GlobalMessageService
  ) { }
}
